package com.qrkontaq.ui.sections.footer

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.Color

@Composable
fun Footer(modifier: Modifier = Modifier) {
    Box(
        FooterStyle
            .toModifier()
            .backgroundColor(Color.black)
            .then(modifier)
            .id("contacts"),
        contentAlignment = Alignment.Center
    ) {
        Box(Modifier.displayIfAtLeast(Breakpoint.MD)) {
            FooterDesktop()
        }
        Box(Modifier.displayUntil(Breakpoint.MD)) {
            FooterMobile()
        }
    }
}
